
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { getuserCurrentApp } from '@/utils/cookies.ts'
import { GYGLISAUDIAPI } from '@/api/gygl'

@Component({
  components: {}
})
export default class Home extends Vue {
  public $echarts: any;
  private numCard = [
    {
      tit: '总数量',
      num: '',
      icon: 'quanbu'
    },
    {
      tit: '待受理',
      num: '',
      icon: 'pengding'
    },
    {
      tit: '处理中',
      num: '',
      icon: 'accepted'
    },
    {
      tit: '已完成',
      num: '',
      icon: 'finished'
    },
    {
      tit: '已驳回',
      num: '',
      icon: 'forward'
    },
    {
      tit: '已撤销',
      num: '',
      icon: 'cancel'
    },
    {
      tit: '已挂起',
      num: '',
      icon: 'Send'
    }
  ];

  private rankNum = [10, 10];
  private rankNumOptions = [10, 20, 30, 50];
  private rankPeople: any[] = [];
  private networkPeople = []; // 工单排行榜
  private deptSubmitData = []; // 部门提单排行
  private deptRankPeople: any[] = [];
  private teacherChart: any;
  private pieChildData = {}; // 子问题类型data{}
  private slaData = {
    recv_sla: 0,
    finish_sla: 0,
    total_rate: 0,
    gygl_ar: 0
    // network_re: 0,
    // network_ir: 0
  }; // 返回SLA数据

  private pieDataLoading = false;

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get routerName() {
    return this.$route.name
  }

  @Watch('sidebar.opened')
  private resizeEchart() {
    setTimeout(() => {
      this.teacherChart.resize()
    }, 500)
  }

  @Watch('$route')
  private routerChange() {
    // 获取SLA数据
    if (this.$route.name === 'allStatistic') {
      this.getSystemSLA()
    }
  }

  // navbar日期值
  get navbarDate() {
    return AppModule.navbarDate
  }

  // navbar日期筛选框改变时，刷新
  @Watch('navbarDate')
  private onNavbarDateChange() {
    this.rankNum = [10, 10]
    this.getAuditData()
    this.getRankData(10, 'all')
    this.getDeptSubmitRankData(10)
    this.getPieData()
    // 获取SLA数据
    if (this.$route.name === 'allStatistic') {
      this.getSystemSLA()
    }
  }

  mounted() {
    this.getAuditData()
    this.getPieData()
    this.getRankData(10, 'all')
    this.getDeptSubmitRankData(10)
    // 获取SLA数据
    if (this.$route.name === 'allStatistic') {
      this.getSystemSLA()
    }

    // 展示navbar时间筛选框；
    AppModule.SetShowNavbarDate(true)
  }

  beforeDestroy() {
    // 隐藏navbar时间筛选框；
    AppModule.SetShowNavbarDate(false)
  }

  // draw柱状图
  private drawBarEchart(tutorEchartData: []) {
    const nameArr: any[] = ['老师工单']
    const valueArr: any[] = [[], []]
    const xData: any[] = []

    tutorEchartData.map((item: any) => {
      xData.push(item.name)
      valueArr[0].push(item.value)
    })
    const seriesData: any[] = []
    nameArr.map((item, index) => [
      seriesData.push({
        name: item,
        type: 'bar',
        smooth: true,
        data: valueArr[index],
        itemStyle: {
          // 上方显示数值
          normal: {
            label: {
              show: true, // 开启显示
              position: 'top'
            }
          }
        }
      })
    ])
    // 基于准备好的dom，初始化echarts实例
    this.teacherChart = this.$echarts.init(
      document.getElementById('teacherEcharts')
    )
    // 绘制图表
    this.teacherChart.setOption(
      this.setBarEchartOption('工单概览', xData, seriesData)
    )
    window.addEventListener('resize', () => {
      this.teacherChart.resize()
    })
  }

  private setBarEchartOption(tit: string, x: Array<string>, seriesData: any) {
    return {
      title: {
        text: tit,
        x: 'center',
        textStyle: {
          color: '#2d436a',
          lineHeight: 36
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let relVal = params[0].name
          const colors = ['#36cbcb', '#5e83fb']
          for (let i = 0, l = params.length; i < l; i++) {
            relVal +=
              '<br/><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:' +
              colors[i] +
              ';"></span> ' +
              params[i].seriesName +
              ' : ' +
              params[i].value +
              ' 个'
          }
          return relVal
        }
      },
      legend: {
        // data: ['班主任工单', 'LP(学规)工单'],
        data: ['老师工单'],
        right: '10px',
        top: '30px'
      },
      xAxis: {
        data: x
      },
      yAxis: {
        type: 'value',
        name: '工单数/条',
        minInterval: 1
      },
      // 设置中间内容距离div的距离，也就是内边距
      grid: {
        top: 80,
        left: 40,
        right: 20,
        width: 'auto',
        height: 'auto'
      },
      series: seriesData,
      barWidth: 26,
      color: ['#36cbcb', '#5e83fb']
    }
  }

  // draw饼图
  private drawPieEchart(title: string, data: [], index: number) {
    const pieChart = this.$echarts.init(
      document.getElementById('pieEcharts' + index)
    )
    pieChart.setOption(this.setPieEchartOption(title, data))
    pieChart.on('click', this.pieClickEvent)
    window.addEventListener('resize', () => {
      pieChart.resize()
    })
  }

  private pieClickEvent(params: any) {
    console.log(params)
    if (params.seriesType === 'pie') {
      const issueName = params.data.name
      const parentId = params.data.parent_id
      this.$router.push({
        name: 'allOrders',
        query: { issueName: issueName, parentId: parentId }
      })
    }
  }

  private setPieEchartOption(titleName: string, data: any) {
    // 去除值为0的数据，不展示
    let newPieData: any = []
    let count = 0
    data.forEach((item: any) => {
      if (item.value > 0) {
        count++
        newPieData.push(item)
      }
    })
    if (count === 0) {
      // 所有数据都为0时显示
      newPieData = data
    }
    return {
      title: {
        text: titleName,
        left: 'center',
        padding: 20
      },
      color: [
        '#5e83fb',
        '#36cbcb',
        '#3aa1ff',
        '#4ecb73',
        '#9bd344',
        '#f8da47',
        '#ffbb67',
        '#ee706d',
        '#806dee',
        '#7c8cf5'
      ],
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} 个'
      },
      series: [
        {
          name: titleName,
          type: 'pie',
          radius: ['25%', '45%'],
          top: 20,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 1
          },
          labelLine: {
            normal: {
              length: '20',
              length2: Math.max(
                30,
                Number(`${(0.2 * 100 * window.innerWidth) / 750}`)
              ),
              position: 'outer',
              color: '#3d4954',
              padding: [0]
            }
          },
          label: {
            normal: {
              formatter: '{c|{c}}个({a|{d}%})\n{b|{b}}',
              borderWidth: 0,
              borderRadius: 4,
              shadowColor: '#999',
              padding: [0, -8 * 4.5],
              color: '#3d4954',
              rich: {
                a: {
                  // 百分比
                  align: 'left',
                  color: '#3d4954',
                  lineHeight: 18
                },
                b: {
                  // 百分比说明
                  align: 'left',
                  color: '#3d4954',
                  lineHeight: 18
                }
              }
            }
          },
          data: newPieData
        }
      ]
    }
  }

  // 获取所有工单统计 + 柱状图分布
  private async getAuditData() {
    let apiName = ''
    if (this.routerName === 'ownStatistic') {
      apiName = 'getOwnAudit'
    } else if (this.routerName === 'areaStatistic') {
      apiName = 'getAreaAudit'
    } else {
      apiName = 'getAllAudit'
    }
    await (GYGLISAUDIAPI as any)
      // eslint-disable-next-line no-unexpected-multiline
      [apiName]({
        from: this.navbarDate ? this.navbarDate[0] : '',
        to: this.navbarDate ? this.navbarDate[1] : '',
        audit_type: 'ticket',
        app_id: this.userCurrentApp
      })
      .then((res: any) => {
        if (res.stat === 1) {
          this.numCard[0].num = res.data.count
          this.numCard[1].num = res.data.total.filter((item: any) => {
            return item.status === 1
          })[0].value
          this.numCard[2].num = res.data.total.filter((item: any) => {
            return item.status === 2
          })[0].value
          this.numCard[3].num = res.data.total.filter((item: any) => {
            return item.status === 3
          })[0].value
          this.numCard[4].num = res.data.total.filter((item: any) => {
            return item.status === 4
          })[0].value
          this.numCard[5].num = res.data.total.filter((item: any) => {
            return item.status === 5
          })[0].value
          this.numCard[6].num = res.data.total.filter((item: any) => {
            return item.status === 6
          })[0].value
          AppModule.SetShowNavbarPlace(res.data.place)
          const tutorEchartData = res.data.total
          tutorEchartData.sort((a: any, b: any) => {
            // 按照 待受理——处理中——已完成——已驳回——已撤销 的顺序排序
            return a.status - b.status
          })

          this.drawBarEchart(tutorEchartData)
        }
      })
  }

  // 获取系统SLA数据
  private async getSystemSLA() {
    await (GYGLISAUDIAPI as any)
      .getSystemSLAData({
        from: this.navbarDate ? this.navbarDate[0] : '',
        to: this.navbarDate ? this.navbarDate[1] : '',
        app_id: this.userCurrentApp
      })
      .then((res: any) => {
        if (res.stat === 1) {
          this.slaData = res.data
        }
      })
  }

  // 获取完成率排行榜数据
  private async getRankData(count: number, type: string) {
    let apiName = ''
    if (this.routerName === 'ownStatistic') {
      apiName = 'getOwnAudit'
    } else if (this.routerName === 'areaStatistic') {
      apiName = 'getAreaAudit'
    } else {
      apiName = 'getAllAudit'
    }
    await (GYGLISAUDIAPI as any)
      // eslint-disable-next-line no-unexpected-multiline
      [apiName]({
        from: this.navbarDate ? this.navbarDate[0] : '',
        to: this.navbarDate ? this.navbarDate[1] : '',
        audit_type: 'accept_user',
        display_count: count,
        app_id: this.userCurrentApp
      })
      .then((res: any) => {
        if (res.stat === 1) {
          this.networkPeople = res.data.done.gygl
          this.rankPeople = [this.networkPeople]
        }
      })
  }

  // 获取部门提单排行榜数据
  private async getDeptSubmitRankData(count: number) {
    const apiName = 'getOwnAudit'
    await (GYGLISAUDIAPI as any)
      // eslint-disable-next-line no-unexpected-multiline
      [apiName]({
        from: this.navbarDate ? this.navbarDate[0] : '',
        to: this.navbarDate ? this.navbarDate[1] : '',
        audit_type: 'dept_submit',
        display_count: count,
        app_id: this.userCurrentApp
      })
      .then((res: any) => {
        if (res.stat === 1) {
          this.deptSubmitData = res.data.dept_submit.total
          this.deptRankPeople = [this.deptSubmitData]
        }
      })
  }

  // 获取问题类型饼图分布
  private async getPieData() {
    this.pieDataLoading = true
    let apiName = ''
    if (this.routerName === 'ownStatistic') {
      apiName = 'getOwnAudit'
    } else if (this.routerName === 'areaStatistic') {
      apiName = 'getAreaAudit'
    } else {
      apiName = 'getAllAudit'
    }
    await (GYGLISAUDIAPI as any)
      // eslint-disable-next-line no-unexpected-multiline
      [apiName]({
        from: this.navbarDate ? this.navbarDate[0] : '',
        to: this.navbarDate ? this.navbarDate[1] : '',
        audit_type: 'issue_type',
        app_id: this.userCurrentApp
      })
      .then((res: any) => {
        if (res.stat === 1) {
          this.pieDataLoading = false
          this.pieChildData = res.data.level_2_audit // 各种子类型data
          this.drawPieEchart('问题总览', res.data.level_1_audit, 0)
          this.$nextTick(() => {
            let index = 0
            for (const i in this.pieChildData) {
              index++
              this.drawPieEchart(i, (this.pieChildData as any)[i], index)
            }
          })
        }
      })
  }
}
